module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeout,
      "color": _vm.color,
      "multi-line": _vm.mode === 'multi-line',
      "vertical": _vm.mode === 'vertical'
    },
    on: {
      "input": _vm.inputHandler
    },
    model: {
      value: (_vm.display),
      callback: function($$v) {
        _vm.display = $$v
      },
      expression: "display"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.displayText)
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": _vm.closeHandler
    }
  }, [_vm._v(_vm._s(_vm.closeText))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f502cc1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Message.vue
// module id = 14
// module chunks = 0